import type { EffectResolutionContext, EffectMagnitude, GameplayEffect, GameplayEffectResolution } from './effectTypes';

function resolveMagnitude(magnitude: EffectMagnitude, context: EffectResolutionContext): number {
  if (magnitude.mode === 'flat') return magnitude.value;
  if (magnitude.mode === 'target_max_hp_ratio') return context.target.maxHp * magnitude.ratio;

  const sourceAttribute = context.source?.attributes[magnitude.attribute] || 0;
  const effectiveAttribute = Math.max(magnitude.minimumAttribute, sourceAttribute);
  const sourceLevel = Math.max(0, context.source?.level || 0);
  return effectiveAttribute * magnitude.coefficient * (1 + sourceLevel * magnitude.levelCoefficient);
}

/**
 * 解析单个通用效果，不直接修改调用方状态。
 */
export function resolveGameplayEffect(
  effect: GameplayEffect,
  context: EffectResolutionContext,
): GameplayEffectResolution {
  const requestedValue = Math.max(0, Math.round(resolveMagnitude(effect.magnitude, context)));
  const currentHp = Math.max(0, Math.min(context.target.hp, context.target.maxHp));
  const nextHp = Math.min(context.target.maxHp, currentHp + requestedValue);
  const appliedValue = nextHp - currentHp;
  const reason = requestedValue <= 0 ? 'zero_magnitude' : 'target_at_full_health';

  return {
    type: 'heal',
    requestedValue,
    appliedValue,
    nextHp,
    success: appliedValue > 0,
    ...(appliedValue > 0 ? {} : { reason }),
  };
}
